<template>
  <v-list-item three-line key="i" class="px-5 SendboxItem2" :class="`item-bottom-border`">
    <!-- <v-list-item three-line
                               key="i"
                               class="px-5"
                               :class="`border-top-${themeName}`"> -->
    <v-list-item-content>
      <v-list-item-title v-html="title" class="text-subtitle-2"></v-list-item-title>
      <v-list-item-subtitle class="location pb-1" v-html="location"></v-list-item-subtitle>
      <v-list-item-subtitle :class="`subtitle-${themeName}`" class="mb-0">
        <!--        <span v-html="text"></span>-->
        <span v-for="(item, index) in text.split('|')" :key="index">
          <span v-if="item.indexOf('<em>') >= 0">
            <v-chip dark :color="chipColor" class="px-2 mr-1" x-small v-html="item"></v-chip>
          </span>
          <span v-else v-html="item"></span>
        </span>
      </v-list-item-subtitle>

      <v-list-item-subtitle v-if="sendboxItem.sent" class="mt-0 pt-0" :class="`subtitle-${themeName}`">
        <span>{{ $t('sendbox.sent') }}&nbsp;</span>
        <v-chip dark :color="chipColor" class="px-2" x-small v-if="sendboxItem.sent">{{ renderSentDateTime(sendboxItem.sent) }} </v-chip>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import common from '@/mixins/common';

export default {
  mixins: [common],
  props: {
    sendboxItem: Object,
  },

  methods: {
    renderSentDateTime(sentTimeInMs) {
      return dateUtils.formatAsLocaleDateTime(new Date(sentTimeInMs));
    },
  },
  computed: {
    chipColor() {
      return this.darkMode ? '#505050' : '#909090';
    },
    subject() {
      return this.sendboxItem.subject;
    },
    userState() {
      return this.subject ? this.subject._userState : null;
    },
    userNotification() {
      return this.sendboxItem.userNotification;
    },

    title() {
      return this.userNotification ? this.userNotification.title : 'ohne Titel';
    },

    text() {
      if (this.userState) {
        // IMPORTANT: The actionDateTime has been skipped because we do not have a valid date for favorite actions
        // let date = dateUtils.parseISOString(this.userState.userdatemodified);
        let actionText = this.$t(this.sendboxItem.action);
        // let actionDateTime = date.getMonth ? dateUtils.formatAsLocaleDateTime(date) : 'no date';
        let type = this.$t(`sendbox.type.${this.userState._type}`);

        return this.$t('sendbox.actionText', { type, action: actionText });
        //return this.$t('sendbox.actionText', { type, dateTime: actionDateTime, action: actionText });
      }
      return this.userNotification.text;
      // let actionText = this.$t(this.sendboxItem.action);
      // let actionDateTime = 'no date';
      // let type = this.$t(`sendbox.type.unknown`);

      // return this.$t('sendbox.actionText', { type, dateTime: actionDateTime, action: actionText });
    },
    location() {
      if (!this.subject) return '';
      const i = this.subject;
      //console.debug('this.subject', JSON.stringify(this.subject, null, 2));

      let displayLocation = `${this.$t(i._moduleTitle)}</b>${i._displayLocation ? ': ' + i._displayLocation.slice(0, i._displayLocation.length - 1) : ''}`;
      return `${this.$t(this.subject.module)} <b>${displayLocation}</b>`;
    },
  },
};
</script>

<style scoped>
.location {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  font-size: 0.6rem !important;
}

.subtitle-dark,
.subtitle-light {
  line-height: 1.2;
  font-size: 0.75rem !important;
}

.subtitle-dark em,
.subtitle-light em {
  font-style: normal;
}
</style>
